import React from 'react';
import Button from '../../../../common/Button';
import { Modal, notification } from 'antd';
import { Formik, ErrorMessage } from 'formik';
import Input from 'formik-antd/lib/input';
import Form from 'formik-antd/lib/form';
import SubmitButton from '../../../../common/SubmitButton';
import { string, object } from 'yup';
import Api from '../../../services/Api';
import {
  Flex,
  FieldError,
  openNotificationWithIcon,
} from '@mss/mss-component-library';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
type AddUserModalProps = {
  closeModal: () => void;
};

export default function AddUserModal({ closeModal }: AddUserModalProps) {
  const [t] = useTranslation(['authorization', 'common']);
  const history = useHistory();
  const queryClient = useQueryClient();
  const { url } = useRouteMatch();
  return (
    <Modal
      title={t(`Add users to this site manager`)}
      visible
      closable={false}
      footer={[
        <Button ghost variant="primary" onClick={closeModal}>
          {t('Cancel')}
        </Button>,
      ]}
    >
      <p>
        {t(
          'Provide the email address of the user you would like to add to this site manager. Please contact your local MSS administrator if the email address is not recognized by MSS.'
        )}
      </p>
      <Formik
        onSubmit={async (values: any) => {
          const result = await Api.user.add(values);
          if (result.status >= 200 && result.status < 300) {
            const response = await result.json();
            openNotificationWithIcon(
              notification.success,
              t('User added'),
              t('User successfully added to the site manager.')
            );
            await queryClient.invalidateQueries({ queryKey: ['users'] });

            history.push(`${url}/${response.id}`);
          } else {
            if (result.status === 404) {
              openNotificationWithIcon(
                notification.error,
                t('Adding user failed'),
                t(
                  `The user with email (VALUESEMAIL) could not be found and therefore not added to this site.`,
                  { valuesEmail: values.email }
                )
              );
            } else {
              openNotificationWithIcon(
                notification.error,
                t('Adding user failed'),
                t(
                  'Due to technical issues the user could not be added to the site. Please try again later.'
                )
              );
            }
          }
        }}
        initialValues={{ email: '' }}
        validationSchema={object().shape({
          email: string()
            .email(t('Please enter a valid email address'))
            .required(t('Please enter a valid email address')),
        })}
      >
        {({ values, errors, handleChange, handleBlur }) => {
          return (
            <Form>
              <Flex h="start" v="center">
                <Input
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  style={{ flex: '0 1 90%' }}
                />
                <SubmitButton
                  disabled={!!errors.email || !values.email}
                  style={{ flex: '0 0 80px' }}
                >
                  {t('Add')}
                </SubmitButton>
              </Flex>
              <FieldError>
                <ErrorMessage name={'email'} />
              </FieldError>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
}
